import React, { useEffect, useRef } from 'react';

import { useIntersection } from '~/hooks/useIntersectionObserver';
import { useTrigger } from '~/hooks/useTrigger';

interface IPageFetcher {
  fetch: () => void;
}

export const PageFetcher: React.FC<IPageFetcher> = (props) => {
  const { fetch } = props;
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
  const [enabled, inViewHook] = useTrigger();
  useIntersection({ ref, callback: inViewHook.activate });

  useEffect(() => {
    if (enabled) {
      fetch();
    }
  }, [enabled, fetch]);

  return <div ref={ref} />
}
